var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',{scopedSlots:_vm._u([{key:"title",fn:function(){return [(_vm.pageTitle)?_c('PageTitle',[_vm._v(" "+_vm._s(_vm.pageTitle)+" ")]):_vm._e()]},proxy:true}])},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }